import { apiGet } from "api/callApi";
import { DropdownWithSearch } from "InnoUI/innoinput";
import { Select } from "antd";
import { useEffect, useState, useRef } from "react";

const ProjectTemplateOptionDropdown = (props) => {
  const {
    onChange,
    templateOption,
    name,
    defaultValue,
    disabledDropdown,
    width = "90%",
    projectId,
    multiSelect = false,
    value,
    autoOpen = false,
    asChangePicker = false,
  } = props;

  const [template, setTemplate] = useState(templateOption || []);
  const [isOpen, setIsOpen] = useState(autoOpen);
  const [searchText, setSearchText] = useState("");

  const dropdownRef = useRef(null);

  const getAllTemplate = async () => {
    if (!templateOption || templateOption.length === 0) {
      try {
        if (projectId) {
          const response = await apiGet(
            `/v1/projects/templateoptions/${projectId}`,
            false,
          );

          setTemplate(
            response.data.map((t) => ({
              id: t.folderTemplateId,
              label: t.folderTemplateName,
            })),
          );
        } else {
          const response = await apiGet(`/v1/templates`, false);

          setTemplate(
            response.data.map((t) => ({
              id: t.id,
              label: t.name,
            })),
          );
        }
      } catch (error) {
        console.error("Error fetching templates", error);
      }
    }
  };

  useEffect(() => {
    if (templateOption && templateOption.length > 0) {
      setTemplate(templateOption);
    } else {
      getAllTemplate();
    }
  }, [templateOption, projectId]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (multiSelect) {
    return (
      <Select
        mode="multiple"
        placeholder="Select Folder Templates"
        value={value || []}
        options={template.map((t) => ({
          value: t.id,
          label: t.label,
        }))}
        onChange={(values) => onChange(name, values)}
        style={{ width, fontSize: "12px" }}
        optionFilterProp="label"
        maxTagCount={3}
        maxTagTextLength={12}
        disabled={disabledDropdown}
      />
    );
  }

  const handleDropdownChange = (val) => {
    const selectedOption = template.find(
      (option) => String(option.id) === String(val),
    );

    const selectedLabel = selectedOption ? selectedOption.label : "";

    onChange(name, val, selectedLabel);
  };

  if (asChangePicker) {
    const filteredTemplates = template.filter((item) =>
      item.label?.toLowerCase().includes(searchText.toLowerCase()),
    );

    return (
      <div
        ref={dropdownRef}
        style={{
          position: "relative",
          display: "inline-block",
        }}
      >
        <span
          onClick={() => !disabledDropdown && setIsOpen((prev) => !prev)}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "4px",
            padding: "2px 8px",
            border: "1px solid #ED850C",
            borderRadius: "4px",
            color: "#ED850C",
            cursor: disabledDropdown ? "not-allowed" : "pointer",
            fontSize: "12px",
            background: "#fff",
            userSelect: "none",
            minHeight: "26px",
          }}
        >
          Change ▾
        </span>

        {isOpen && (
          <div
            style={{
              position: "absolute",
              top: "100%",
              right: 0,
              marginTop: "4px",
              width: "260px",
              background: "#fff",
              border: "1px solid #d9d9d9",
              borderRadius: "6px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              zIndex: 99999,
            }}
          >
            <div
              style={{
                padding: "8px",
                borderBottom: "1px solid #f0f0f0",
              }}
            >
              <input
                type="text"
                placeholder="Search template..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{
                  width: "100%",
                  padding: "6px 8px",
                  border: "1px solid #d9d9d9",
                  borderRadius: "4px",
                  outline: "none",
                  fontSize: "12px",
                  boxSizing: "border-box",
                }}
              />
            </div>

            <div
              style={{
                maxHeight: "220px",
                overflowY: "auto",
              }}
            >
              {filteredTemplates.length > 0 ? (
                filteredTemplates.map((item) => (
                  <div
                    key={item.id}
                    title={item.label}
                    onClick={() => {
                      onChange(name, item.id, item.label);

                      setIsOpen(false);
                      setSearchText("");
                    }}
                    style={{
                      padding: "8px 12px",
                      cursor: "pointer",
                      fontSize: "12px",
                      borderBottom: "1px solid #f5f5f5",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "#fff7e6";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "#fff";
                    }}
                  >
                    {item.label}
                  </div>
                ))
              ) : (
                <div
                  style={{
                    padding: "12px",
                    textAlign: "center",
                    color: "#999",
                    fontSize: "12px",
                  }}
                >
                  No templates found
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <DropdownWithSearch
      defaultValue={defaultValue}
      placeholder="Select Folder Template"
      options={template}
      onChange={handleDropdownChange}
      borderColor="#ED850C"
      disabled={true}
      width={width}
      dropdowType={"ProjectTemplateOptionDropdown"}
      disabledDropdown={disabledDropdown}
      defaultOpen={autoOpen}
    />
  );
};

export default ProjectTemplateOptionDropdown;
